// Multilingual content for Francesca De Salvia landing page.

export const CONTACT_INFO = {
  phone: "+34 694461956",
  phoneHref: "tel:+34694461956",
  whatsapp: "https://wa.me/34694461956",
  email: "info@francescadesalvia.com",
  location: "Playa Paraíso, Adeje · Tenerife",
  addressFull: "Calle El Pinque, 12, 38678 Playa Paraíso, Adeje (Tenerife)",
  mapUrl: "https://maps.app.goo.gl/7hLNLR6FofTowDyG8",
  reviewUrl: "https://maps.google.com/?cid=4543852093846284419",
  mapEmbed:
    "https://www.google.com/maps?q=Pranic+Healing+Tenerife+-+Francesca+De+Salvia&ll=28.1275436,-16.7669973&z=14&output=embed",
  instagram: "https://www.instagram.com/francescadesalvia",
};

export const TACHYON_IMAGE =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_7107c802-c422-4745-8ee6-c6a54abed190/artifacts/3687jh3l_294e065d-78aa-4e5d-b804-7ee17fc6d3aa.jpeg";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1518495973542-4542c06a5843?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  healing:
    "https://images.pexels.com/photos/5240734/pexels-photo-5240734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  meditation:
    "https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mudra:
    "https://images.pexels.com/photos/5201529/pexels-photo-5201529.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  spiritual:
    "https://images.unsplash.com/photo-1562751362-404243c2eea3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  bowls:
    "https://images.pexels.com/photos/7113561/pexels-photo-7113561.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

export const LANGUAGES = [
  { code: "it", label: "IT", name: "Italiano", href: "/it/" },
  { code: "es", label: "ES", name: "Español", href: "/" },
  { code: "en", label: "EN", name: "English", href: "/en/" },
];

export const PAGE_SEO = {
  es: {
    title: "Pranic Healing Tenerife | Terapia Pránica - Reserva tu sesión",
    description:
      "Pranic Healing en Tenerife para recuperar equilibrio emocional, claridad mental y bienestar energético. Terapia pránica personalizada. Reserva tu sesión.",
    keywords:
      "Pranic Healing Tenerife, psicoterapia pránica, terapia energética Tenerife, sanación energética, cámara taquiónica, Playa Paraíso, Adeje",
    locale: "es_ES",
    url: "https://francescadesalvia.com/",
    imageAlt: "Francesca De Salvia - Terapia Pránica en Tenerife",
    schemaDescription:
      "Psicoterapia Pránica y Pranic Healing en Tenerife. Terapia energética para recuperar equilibrio emocional, claridad mental y bienestar. Cámara Taquiónica. Sesiones presenciales y online.",
  },
  en: {
    title: "Pranic Healing Tenerife | Energy Therapy & Tachyon Chamber",
    description:
      "Pranic Healing in Tenerife for emotional wellbeing, mental clarity and energetic balance. Personalised energy therapy, in person and online.",
    keywords:
      "Pranic Healing Tenerife, energy healing Tenerife, pranic psychotherapy, Tachyon Chamber Tenerife, emotional wellbeing, Adeje",
    locale: "en_GB",
    url: "https://francescadesalvia.com/en/",
    imageAlt: "Francesca De Salvia - Pranic Healing in Tenerife",
    schemaDescription:
      "Pranic psychotherapy and Pranic Healing in Tenerife. Energy therapy for emotional wellbeing, mental clarity and balance. Tachyon Chamber. In-person and online sessions.",
  },
  it: {
    title: "Pranic Healing Tenerife | Psicoterapia Pranica e Camera Tachionica",
    description:
      "Pranic Healing a Tenerife per benessere emotivo, chiarezza mentale ed equilibrio energetico. Sessioni personalizzate in presenza e online.",
    keywords:
      "Pranic Healing Tenerife, psicoterapia pranica, terapia energetica Tenerife, Camera Tachionica, benessere emotivo, Adeje",
    locale: "it_IT",
    url: "https://francescadesalvia.com/it/",
    imageAlt: "Francesca De Salvia - Psicoterapia Pranica a Tenerife",
    schemaDescription:
      "Psicoterapia Pranica e Pranic Healing a Tenerife. Terapia energetica per il benessere emotivo, la chiarezza mentale e l'equilibrio. Camera Tachionica. Sessioni in presenza e online.",
  },
};

export const translations = {
  it: {
    nav: {
      home: "Home",
      about: "Chi Sono",
      pranic: "Psicoterapia Pranica",
      tachyon: "Camera Tachionica",
      contact: "Contatti",
      cta: "Prenota una sessione",
    },
    hero: {
      kicker: "Pranic Healing · Tenerife",
      title: "Psicoterapia Pranica",
      subtitle:
        "Benessere emotivo ed equilibrio energetico. Una terapia energetica naturale che aiuta a ritrovare equilibrio psicologico, chiarezza mentale e serenità interiore.",
      cta1: "Scopri di più",
      cta2: "Contattami",
    },
    intro: {
      title: "Guarigione energetica per il tuo equilibrio",
      p1: "Attraverso l'armonizzazione dell'energia vitale, questa pratica lavora su stress, ansia, tensioni emotive e affaticamento mentale, favorendo una profonda sensazione di calma e benessere.",
      p2: "Il Pranic Healing non sostituisce la psicoterapia né la medicina tradizionale, ma le completa, offrendo uno spazio di consapevolezza dove il benessere nasce dall'armonia dell'energia.",
      listTitle: "Ideale per chi desidera:",
      list: [
        "Ritrovare stabilità e chiarezza mentale",
        "Liberare emozioni e pensieri ripetitivi",
        "Migliorare il sonno e l'energia quotidiana",
        "Sentirsi più presenti, equilibrati e in pace con sé stessi",
      ],
    },
    about: {
      kicker: "Chi Sono",
      title: "Francesca De Salvia",
      role: "Psicoterapeuta Pranica · Operatrice di Pranic Healing",
      p1: "Accompagno le persone in percorsi di crescita personale, trasformazione emotiva e guarigione interiore. Ogni sessione è uno spazio di ascolto e rigenerazione, dove le energie bloccate vengono purificate e ricaricate.",
      p2: "Il mio approccio è dolce, non invasivo e complementare: unisce la sensibilità della psicoterapia alla profondità del lavoro energetico, perché il benessere nasce dall'armonia tra mente, corpo ed energia.",
      quote:
        "Il benessere nasce quando mente, corpo ed energia tornano a fluire in armonia.",
    },
    pranic: {
      kicker: "Il Metodo",
      title: "Perché la psicoterapia pranica può essere più rapida?",
      p1: "La psicoterapia pranica agisce direttamente sul campo energetico ed emotivo, dove spesso si originano i blocchi mentali e i modelli di sofferenza.",
      p2: "Mentre la psicoterapia tradizionale lavora principalmente attraverso la parola e il ragionamento consapevole, il Pranic Healing interviene anche nei livelli più sottili, dove le emozioni si depositano prima di trasformarsi in pensieri ripetitivi o sintomi fisici.",
      p3: "Pulendo e riequilibrando queste energie congestionate, la persona può liberare rapidamente emozioni represse, paure e tensioni. Questo non sostituisce il lavoro profondo della psicoterapia, ma ne accelera il processo: la mente diventa più recettiva, chiara e leggera.",
      cards: [
        { title: "Riduzione dello stress", text: "Meno pensieri ossessivi e maggiore quiete interiore." },
        { title: "Chiarezza emotiva", text: "Emozioni più leggibili e integrate con naturalezza." },
        { title: "Benessere integrale", text: "Una sensazione diffusa di equilibrio in poche sessioni." },
      ],
    },
    tachyon: {
      kicker: "Nuova Offerta",
      title: "Camera Tachionica",
      subtitle:
        "Uno spazio energetico esclusivo per un riequilibrio profondo di corpo, mente ed emozioni.",
      p1: "La Camera Tachionica è un ambiente energetico progettato per immergerti in un campo di energia tachionica coerente. Sdraiandoti nella camera, il corpo riceve un flusso naturale che favorisce il rilassamento profondo, la rigenerazione cellulare e il riequilibrio dei centri energetici.",
      p2: "È un'esperienza dolce e non invasiva, ideale come complemento alle sessioni di Pranic Healing per amplificare la sensazione di calma, chiarezza e vitalità.",
      benefitsTitle: "Benefici principali",
      benefits: [
        "Rilassamento profondo e riduzione dello stress",
        "Sostegno alla rigenerazione e all'energia vitale",
        "Riequilibrio dei centri energetici (chakra)",
        "Maggiore chiarezza mentale e serenità",
        "Favorisce il manifestarsi delle situazioni desiderate",
        "Aiuta a sbloccare situazioni ferme o irrisolte",
      ],
      priceLabel: "Sessione singola",
      price: "€60",
      duration: "60 minuti",
      note: "* Durata e prezzo indicativi — personalizzabili in base al percorso.",
      cta: "Prenota la tua sessione",
    },
    contact: {
      kicker: "Contatti",
      title: "Connettiti con il tuo benessere oggi",
      subtitle:
        "Compila il modulo con le tue domande o esponendo il tuo caso e ti risponderò il prima possibile.",
      name: "Il tuo nome",
      email: "La tua email",
      subject: "Oggetto",
      message: "Il tuo messaggio (opzionale)",
      send: "Invia messaggio",
      emailAction: "Invia via email",
      sending: "Invio in corso...",
      success: "Messaggio inviato! Ti risponderò al più presto.",
      mailtoSuccess: "Si è aperta la tua app email. Invia il messaggio per completare il contatto.",
      error: "Si è verificato un errore. Riprova più tardi.",
      phoneLabel: "Telefono",
      emailLabel: "Email",
      locationLabel: "Dove",
      reviewAction: "Lascia una recensione",
      mapTitle: "Dove mi trovo",
    },
    footer: {
      tagline: "Psicoterapia Pranica · Pranic Healing a Tenerife",
      disclaimer:
        "Il Pranic Healing è una pratica complementare e non sostituisce la psicoterapia né la medicina tradizionale.",
      rights: "Tutti i diritti riservati.",
    },
  },

  es: {
    nav: {
      home: "Inicio",
      about: "Sobre Mí",
      pranic: "Psicoterapia Pránica",
      tachyon: "Cámara Taquiónica",
      contact: "Contacto",
      cta: "Reserva una sesión",
    },
    hero: {
      kicker: "Pranic Healing · Tenerife",
      title: "Psicoterapia Pránica",
      subtitle:
        "Bienestar emocional y equilibrio energético. Una terapia energética natural que ayuda a recuperar el equilibrio psicológico, la claridad mental y la serenidad interior.",
      cta1: "Descubre más",
      cta2: "Contáctame",
    },
    intro: {
      title: "Sanación energética para tu equilibrio",
      p1: "A través de la armonización de la energía vital, esta práctica trabaja sobre el estrés, la ansiedad, las tensiones emocionales y el cansancio mental, favoreciendo una profunda sensación de calma y bienestar.",
      p2: "El Pranic Healing no sustituye la psicoterapia ni la medicina tradicional, sino que las complementa, ofreciendo un espacio de consciencia donde el bienestar nace de la armonía de la energía.",
      listTitle: "Ideal para quienes desean:",
      list: [
        "Recuperar la estabilidad y la claridad mental",
        "Liberar emociones y pensamientos repetitivos",
        "Mejorar el sueño y la energía cotidiana",
        "Sentirse más presentes, equilibrados y en paz consigo mismos",
      ],
    },
    about: {
      kicker: "Sobre Mí",
      title: "Francesca De Salvia",
      role: "Psicoterapeuta Pránica · Practicante de Pranic Healing",
      p1: "Acompaño a las personas en procesos de crecimiento personal, transformación emocional y sanación interior. Cada sesión es un espacio de escucha y regeneración, donde las energías bloqueadas se purifican y recargan.",
      p2: "Mi enfoque es suave, no invasivo y complementario: une la sensibilidad de la psicoterapia con la profundidad del trabajo energético, porque el bienestar nace de la armonía entre mente, cuerpo y energía.",
      quote:
        "El bienestar nace cuando mente, cuerpo y energía vuelven a fluir en armonía.",
    },
    pranic: {
      kicker: "El Método",
      title: "¿Por qué la psicoterapia pránica puede ser más rápida?",
      p1: "La psicoterapia pránica actúa directamente sobre el campo energético y emocional, donde muchas veces se originan los bloqueos mentales y los patrones de sufrimiento.",
      p2: "Mientras que la psicoterapia tradicional trabaja principalmente a través de la palabra y el razonamiento consciente, el Pranic Healing interviene también en los niveles más sutiles, donde las emociones se almacenan antes de convertirse en pensamientos repetitivos o síntomas físicos.",
      p3: "Al limpiar y equilibrar estas energías congestionadas, la persona puede liberar rápidamente emociones reprimidas, miedos o tensiones. Esto no reemplaza el trabajo profundo de la psicoterapia, pero acelera el proceso: la mente se vuelve más receptiva, clara y ligera.",
      cards: [
        { title: "Reducción del estrés", text: "Menos pensamientos obsesivos y mayor calma interior." },
        { title: "Claridad emocional", text: "Emociones más legibles e integradas con naturalidad." },
        { title: "Bienestar integral", text: "Una sensación amplia de equilibrio en pocas sesiones." },
      ],
    },
    tachyon: {
      kicker: "Nueva Oferta",
      title: "Cámara Taquiónica",
      subtitle:
        "Un espacio energético exclusivo para un reequilibrio profundo de cuerpo, mente y emociones.",
      p1: "La Cámara Taquiónica es un ambiente energético diseñado para sumergirte en un campo de energía taquiónica coherente. Al recostarte en la cámara, el cuerpo recibe un flujo natural que favorece la relajación profunda, la regeneración celular y el reequilibrio de los centros energéticos.",
      p2: "Es una experiencia suave y no invasiva, ideal como complemento a las sesiones de Pranic Healing para amplificar la sensación de calma, claridad y vitalidad.",
      benefitsTitle: "Beneficios principales",
      benefits: [
        "Relajación profunda y reducción del estrés",
        "Apoyo a la regeneración y a la energía vital",
        "Reequilibrio de los centros energéticos (chakras)",
        "Mayor claridad mental y serenidad",
        "Favorece la manifestación de las situaciones deseadas",
        "Ayuda a desbloquear situaciones estancadas o sin resolver",
      ],
      priceLabel: "Sesión individual",
      price: "€60",
      duration: "60 minutos",
      note: "* Duración y precio indicativos — personalizables según el proceso.",
      cta: "Reserva tu sesión",
    },
    contact: {
      kicker: "Contacto",
      title: "Conecta con tu bienestar hoy",
      subtitle:
        "Rellena el formulario con tus preguntas o exponiendo tu caso y te contestaré lo antes posible.",
      name: "Tu nombre",
      email: "Tu correo electrónico",
      subject: "Asunto",
      message: "Tu mensaje (opcional)",
      send: "Enviar mensaje",
      emailAction: "Enviar por correo",
      sending: "Enviando...",
      success: "¡Mensaje enviado! Te responderé lo antes posible.",
      mailtoSuccess: "Se ha abierto tu aplicación de correo. Envía el mensaje para completar el contacto.",
      error: "Ha ocurrido un error. Inténtalo de nuevo más tarde.",
      phoneLabel: "Teléfono",
      emailLabel: "Correo",
      locationLabel: "Dónde",
      reviewAction: "Deja una reseña",
      mapTitle: "Dónde me encuentro",
    },
    footer: {
      tagline: "Psicoterapia Pránica · Pranic Healing en Tenerife",
      disclaimer:
        "El Pranic Healing es una práctica complementaria y no sustituye la psicoterapia ni la medicina tradicional.",
      rights: "Todos los derechos reservados.",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      pranic: "Pranic Psychotherapy",
      tachyon: "Tachyon Chamber",
      contact: "Contact",
      cta: "Book a session",
    },
    hero: {
      kicker: "Pranic Healing · Tenerife",
      title: "Pranic Psychotherapy",
      subtitle:
        "Emotional wellbeing and energetic balance. A natural energy therapy that helps restore psychological balance, mental clarity and inner serenity.",
      cta1: "Discover more",
      cta2: "Contact me",
    },
    intro: {
      title: "Energetic healing for your balance",
      p1: "Through the harmonization of vital energy, this practice works on stress, anxiety, emotional tension and mental fatigue, encouraging a deep sense of calm and wellbeing.",
      p2: "Pranic Healing does not replace psychotherapy or traditional medicine, but complements them, offering a space of awareness where wellbeing arises from the harmony of energy.",
      listTitle: "Ideal for those who wish to:",
      list: [
        "Restore stability and mental clarity",
        "Release emotions and repetitive thoughts",
        "Improve sleep and daily energy",
        "Feel more present, balanced and at peace with themselves",
      ],
    },
    about: {
      kicker: "About Me",
      title: "Francesca De Salvia",
      role: "Pranic Psychotherapist · Pranic Healing Practitioner",
      p1: "I accompany people through journeys of personal growth, emotional transformation and inner healing. Each session is a space of listening and regeneration, where blocked energies are purified and recharged.",
      p2: "My approach is gentle, non-invasive and complementary: it unites the sensitivity of psychotherapy with the depth of energy work, because wellbeing arises from the harmony of mind, body and energy.",
      quote:
        "Wellbeing arises when mind, body and energy flow back into harmony.",
    },
    pranic: {
      kicker: "The Method",
      title: "Why can pranic psychotherapy be faster?",
      p1: "Pranic psychotherapy acts directly on the energetic and emotional field, where mental blocks and patterns of suffering often originate.",
      p2: "While traditional psychotherapy works mainly through words and conscious reasoning, Pranic Healing also intervenes on subtler levels, where emotions are stored before turning into repetitive thoughts or physical symptoms.",
      p3: "By cleansing and balancing these congested energies, a person can quickly release repressed emotions, fears and tensions. This does not replace the deep work of psychotherapy, but accelerates the process: the mind becomes more receptive, clear and light.",
      cards: [
        { title: "Stress reduction", text: "Fewer obsessive thoughts and greater inner calm." },
        { title: "Emotional clarity", text: "Emotions that are easier to read and integrate naturally." },
        { title: "Integral wellbeing", text: "A broad sense of balance in just a few sessions." },
      ],
    },
    tachyon: {
      kicker: "New Offering",
      title: "Tachyon Chamber",
      subtitle:
        "An exclusive energetic space for a deep rebalancing of body, mind and emotions.",
      p1: "The Tachyon Chamber is an energetic environment designed to immerse you in a coherent tachyon energy field. Lying inside the chamber, the body receives a natural flow that supports deep relaxation, cellular regeneration and the rebalancing of the energy centres.",
      p2: "It is a gentle, non-invasive experience, ideal as a complement to Pranic Healing sessions to amplify the sense of calm, clarity and vitality.",
      benefitsTitle: "Key benefits",
      benefits: [
        "Deep relaxation and stress reduction",
        "Support for regeneration and vital energy",
        "Rebalancing of the energy centres (chakras)",
        "Greater mental clarity and serenity",
        "Encourages the manifestation of desired situations",
        "Helps to unblock stagnant or unresolved situations",
      ],
      priceLabel: "Single session",
      price: "€60",
      duration: "60 minutes",
      note: "* Duration and price are indicative — customisable to your journey.",
      cta: "Book your session",
    },
    contact: {
      kicker: "Contact",
      title: "Connect with your wellbeing today",
      subtitle:
        "Fill in the form with your questions or describing your case and I will reply as soon as possible.",
      name: "Your name",
      email: "Your email",
      subject: "Subject",
      message: "Your message (optional)",
      send: "Send message",
      emailAction: "Send by email",
      sending: "Sending...",
      success: "Message sent! I will get back to you soon.",
      mailtoSuccess: "Your email app has opened. Send the message to complete your contact request.",
      error: "Something went wrong. Please try again later.",
      phoneLabel: "Phone",
      emailLabel: "Email",
      locationLabel: "Location",
      reviewAction: "Leave a review",
      mapTitle: "Where to find me",
    },
    footer: {
      tagline: "Pranic Psychotherapy · Pranic Healing in Tenerife",
      disclaimer:
        "Pranic Healing is a complementary practice and does not replace psychotherapy or traditional medicine.",
      rights: "All rights reserved.",
    },
  },
};
